export const modifyVastUrl = (vastUrl: string | undefined, program: CmsProgram) => {
  if (!vastUrl) return undefined;

  const url = new URL(vastUrl);
  url.searchParams.set('cmsid', '2688500');
  url.searchParams.set('vid', program._id);

  return url
    .toString()
    .replace(/iu=([^&]+)/, (_, original) => `iu=${program.ads?.adunit?.val ?? original}`);
};

/**
 * Appends the current page URL as the "url" query parameter to the provided adTagUrl.
 * This helps buyers identify the context of the ad request, as required by Google IMA.
 *
 * @param {string} adTagUrl - The base ad tag URL used in the IMA AdsRequest.
 * @returns {string} The updated ad tag URL with the "url" parameter appended.
 */
export const modifyVastUrlCTV = (adTagUrl: string) => {
  if (!adTagUrl) return;

  try {
    const currentUrl =
      typeof window !== 'undefined' && window.location?.href ? window.location.href : 'unknown';
    const tag = new URL(adTagUrl);
    tag.searchParams.set('url', encodeURIComponent(currentUrl));
    return tag.toString();
  } catch (err) {
    console.warn('Failed to append "url" parameter to adTagUrl:', err);
    return adTagUrl;
  }
};
